import React, { useEffect, useRef } from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "videojs-youtube/dist/Youtube.min";

export const StreamVideoPlayer = ({ options, onReady, onUpdateSrc }) => {
	const videoRef = useRef(null);
	const playerRef = useRef(null);

	useEffect(() => {
		const assignSelected = ({ id, src }) =>
			Object.assign(playerRef.current, {
				selectedId: id,
				selectedSrc: src
			});
		const getSelected = () => ({
			id: options.sources[0]?.id,
			src: options.sources[0]?.src
		});

		if (!playerRef.current) {
			const videoElement = document.createElement("video-js");
			videoRef.current.appendChild(videoElement);
			playerRef.current = videojs(videoElement, options, () => {
				onReady(playerRef.current);
				assignSelected(getSelected());
			});
		} else {
			const player = playerRef.current;
			const { id, src } = getSelected();
			const isSourceChanged =
				player.selectedId !== id || player.selectedSrc !== src;
			if (isSourceChanged) {
				onUpdateSrc(player);
				player.autoplay(options.autoplay);
				player.poster("");
				player.error(null);
				player.src(options.sources);
				Object.assign(player, { hasMetadataLoaded: false });
				assignSelected(getSelected());
			}
			onReady(player);
		}
	}, [options, videoRef, onReady, onUpdateSrc]);

	useEffect(() => {
		const player = playerRef.current;

		return () => {
			if (player && !player.isDisposed()) {
				player.dispose();
				playerRef.current = null;
			}
		};
	}, [playerRef]);

	return <div style={{ width: "100%" }} ref={videoRef} />;
};

export default StreamVideoPlayer;
